export enum PublisherCategory {
  Description = 'description',
  Speakers = 'speakers',
  Events = 'events',
}
